export default __webpack_public_path__ + "static/media/ic_stat1.b26b2c41.svg";